import { ROUTES } from "./routes";

export const DISABLE_SCANNER_FOR_ROUTES = [
  ROUTES.WelcomeView as string,
  ROUTES.Registration as string,
  ROUTES.PreloadView as string,
];

export enum ScannerStatus {
  Connected = "Connected",
  Warning = "Warning",
  Error = "Error",
  Offline = "Offline",
}
